(() => {
  const normalizeMenu = () => {
    document.querySelectorAll('.cqz-fallback-nav a').forEach((link) => {
      if (link.textContent.trim() === 'Home') link.textContent = 'Accueil';
    });
  };

  const removeDefaultTitle = (root = document) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (node.nodeValue && node.nodeValue.trim() === 'Default Title') {
        nodes.push(node);
      }
    }
    nodes.forEach((node) => {
      const parent = node.parentElement;
      node.nodeValue = '';
      if (parent && parent.textContent.trim() === '') {
        parent.style.display = 'none';
      }
    });
  };

  const runCleanup = () => {
    normalizeMenu();
    removeDefaultTitle();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runCleanup, { once: true });
  } else {
    runCleanup();
  }

  document.addEventListener('shopify:section:load', runCleanup);
  document.addEventListener('shopify:section:select', runCleanup);

  const observer = new MutationObserver(() => runCleanup());
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

(() => {
  if (window.CQZMainHeaderSmartStickyReady) return;
  window.CQZMainHeaderSmartStickyReady = true;

  let lastScrollY = window.scrollY || 0;
  let hideTimer = null;
  const threshold = 10;
  const topOffset = 80;
  const hideDelay = 300;

  const getMainWhiteHeader = () => document.querySelector('.cqz-fallback-main');

  const cleanupOuterHeaderClasses = () => {
    document
      .querySelectorAll('.cqz-fallback-header, .cqz-fallback-announcement, .cqz-fallback-service')
      .forEach((element) => {
        element.classList.remove(
          'cqz-smart-header',
          'cqz-header-visible',
          'cqz-header-hidden',
          'cqz-main-header-visible',
          'cqz-main-header-hidden',
          'shopify-section-header-hidden'
        );
        if (element !== getMainWhiteHeader()) {
          element.style.transform = '';
        }
      });
  };

  const showMainHeader = (header) => {
    header.classList.remove('cqz-main-header-hidden');
    header.classList.add('cqz-main-header-visible');
  };

  const hideMainHeader = (header) => {
    header.classList.add('cqz-main-header-hidden');
    header.classList.remove('cqz-main-header-visible');
  };

  const handleScroll = () => {
    const header = getMainWhiteHeader();
    if (!header) return;

    cleanupOuterHeaderClasses();

    const currentScrollY = window.scrollY || 0;
    const diff = currentScrollY - lastScrollY;

    if (currentScrollY < topOffset) {
      clearTimeout(hideTimer);
      showMainHeader(header);
      lastScrollY = currentScrollY;
      return;
    }

    if (Math.abs(diff) < threshold) return;

    if (diff > 0) {
      clearTimeout(hideTimer);
      hideTimer = setTimeout(() => {
        hideMainHeader(header);
      }, hideDelay);
    } else {
      clearTimeout(hideTimer);
      showMainHeader(header);
    }

    lastScrollY = currentScrollY;
  };

  const initMainHeader = () => {
    const header = getMainWhiteHeader();
    if (!header) return;
    cleanupOuterHeaderClasses();
    showMainHeader(header);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMainHeader, { once: true });
  } else {
    initMainHeader();
  }

  window.addEventListener('pageshow', initMainHeader);
  window.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('resize', initMainHeader, { passive: true });
})();
